<ng-container [ngSwitch]="question.type">
  <ng-container *ngSwitchCase="'SINGLE_ROW_TEXT'">
    <div #questionDiv class="column D-Active">
      <div class="d-flex justify-content-start column">
        <div class="mt-4 column" *ngFor="let field of question.meta.fields">
          <label
            class="description"
            *ngIf="question.meta.description"
            [innerHTML]="question.meta.description | safeHTML"
          ></label>
          <label class="mb-2 survey-label 1111">{{ field.label }}</label>
          <input
            [disabled]="disabled"
            class="input-survey-two"
            [(ngModel)]="field.value"
            type="text"
          />
        </div>
      </div>
      <hr />
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'EMAIL_ADDRESS'">
    <div #questionDiv class="column D-Active">
      <div class="d-flex justify-content-start column">
        <div class="mt-4 column" *ngFor="let field of question.meta.fields">
          <label
            class="description"
            *ngIf="question.meta.description"
            [innerHTML]="question.meta.description | safeHTML"
          ></label>
          <label class="mb-2 survey-label 2222">{{ field.label }}</label>
          <input
            [disabled]="disabled"
            class="input-survey-two"
            [(ngModel)]="field.value"
            type="text"
          />
        </div>
      </div>
      <hr />
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'COMMENT_BOX'">
    <div #questionDiv class="column D-Active">
      <div class="d-flex justify-content-start column">
        <div *ngFor="let field of question.meta.fields">
          <label
            class="description"
            *ngIf="question.meta.description"
            [innerHTML]="question.meta.description | safeHTML"
          ></label>
          <label class="mb-2 survey-label 3333">{{ field.label }}</label>
          <textarea
            [disabled]="disabled"
            [(ngModel)]="field.value"
            style="
              background-color: white;
              font-size: 20px;
              border: 4px;
              width: 100%;
            "
            rows="2"
            cols="30"
            class="border-4-v4 px-2"
          ></textarea>
        </div>
      </div>
      <hr />
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'CONTACT_INFO'">
    <div #questionDiv class="flex-column D-Active d-act-bg mt-4">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <label class="mb-2 survey-label">{{ question.questionText }}</label>
      <div class="flex-column my-3" *ngFor="let field of question.meta.fields">
        <label class="mb-2 survey-label 4444">{{ field.label }}</label>
        <input
          (keypress)="field.placeholder != 'رقم الهاتف' ? true : numberOnly($event)"
          [disabled]="disabled"
          class="input-survey-two"
          [(ngModel)]="field.value"
          type="text"
        />
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'SELECT_ONE'">
    <div #questionDiv class="column">
      <div class="d-flex justify-content-start column">
        <div class="D-Active mt-2 column d-act-bg">
          <label
            class="description-border color-grey"
            *ngIf="question.meta.description"
            [innerHTML]="question.meta.description | safeHTML"
          ></label>
          <label class="mb-2 survey-label 5555">{{
            question.questionText
          }}</label>
          <div class="column">
            <div class="d-flex" *ngFor="let field of question.meta.fields">
              <p-radioButton
                [disabled]="disabled"
                [(ngModel)]="question.meta.value"
                (ngModelChange)="checkConditionalQuestion()"
                [value]="field.label"
                inputId="{{ field.label }}"
              ></p-radioButton>
              <label for="{{ field.label }}" class="m-2 color-grey">{{
                field.label
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'SELECT_MANY'">
    <div #questionDiv class="column">
      <div class="d-flex justify-content-start column">
        <div class="D-Active mt-4 column d-act-bg">
          <label
            class="description"
            *ngIf="question.meta.description"
            [innerHTML]="question.meta.description | safeHTML"
          ></label>
          <label class="mb-2 survey-label 6666">{{
            question.questionText
          }}</label>
          <div class="column">
            <div class="d-flex" *ngFor="let field of question.meta.fields">
              <p-checkbox
                [disabled]="disabled"
                [(ngModel)]="question.meta.value"
                (ngModelChange)="checkConditionalQuestion()"
                [value]="field.label"
                inputId="{{ field.label }}"
                name="{{ question.questionText }}"
              ></p-checkbox>
              <label for="{{ field.label }}" class="m-2 color-grey">{{
                field.label
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'DROPDOWN_MENU'">
    <div #questionDiv class="D-Active w-100">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <label htmlFor="dd" class="survey-label mb-2">{{
        question.questionText
      }}</label>
      <div class="mb-2 1111">
        <p-dropdown class="ppp-dropdown"
          [disabled]="disabled"
          styleClass="border"
          appendTo="body"
          id="dd"
          placeholder="حدد اختيارا"
          [(ngModel)]="question.meta.value"
          (ngModelChange)="checkConditionalQuestion()"
          [options]="question.meta.fields"
          optionValue="label"
          optionLabel="label"
        >
        </p-dropdown>
      </div>
      <hr />
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'OU_TREE_DROPDOWN'">
    <div #questionDiv class="D-Active w-100">
      <label class="survey-label mb-2">{{ question.questionText }}</label>
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="mb-2 1111" *ngIf="getOuTreeOptionsForQuestion().length">
        <p-treeSelect class="w-100" [options]="getOuTreeOptionsForQuestion()"
          [(ngModel)]="question.meta.selectedOu" appendTo="body" selectionMode="single"
          [placeholder]="'Select OU' | translator" (ngModelChange)="onOuTreeSelect($event)"
          containerStyleClass="w-100" [filter]="true" [disabled]="disabled"
          filterPlaceholder="{{ 'Search filter' | translator }}">
          <ng-template let-node pTemplate="default">
            <div class="d-flex align-items-center">
              <i class="pi pi-sitemap p-2"></i>
              <span class="text-nowrap">{{ node.label }}</span>
            </div>
          </ng-template>
        </p-treeSelect>
      </div>
      <div *ngIf="!getOuTreeOptionsForQuestion().length" class="color-grey">{{ 'OU tree not available' | translator }}</div>
      <hr />
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'SELECT_ONE_IMAGE'">
    <ng-container>
      <!-- select images -->
      <div #questionDiv class="D-Active">
        <label
          class="description"
          *ngIf="question.meta.description"
          [innerHTML]="question.meta.description | safeHTML"
        ></label>
        <div class="my-3">
          <span class="heading">
            {{ question.questionText }}
          </span>
        </div>
        <div class="row py-3">
          <div
            class="col-12 col-md-6 p-2 my-2"
            *ngFor="let field of question.meta.fields"
          >
            <div
              (click)="handleClick(question, field)"
              class="m-2 {{
                question.meta.value == field.label
                  ? 'img-select-active'
                  : 'img-select'
              }} "
            >
              <img class="select-width" src="{{ staticFileUrl + field.url }}" />
              <span class="w-200px-icon my-2 px-3">{{ field.label }}</span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <!-- select images END -->
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'SELECT_MANY_IMAGE'">
    <!-- select multiple images -->
    <div #questionDiv class="D-Active">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <div class="row py-3">
        <div
          class="col-12 col-md-6 p-2 my-2"
          *ngFor="let field of question.meta.fields; let fieldIndex = index"
        >
          <div
            (click)="
              disabled ? null : addOrRemoveImageFromList(question, field.label)
            "
            class="m-2 {{
              question.meta.value.includes(field.label)
                ? 'img-select-active'
                : 'img-select'
            }}"
          >
            <img class="select-width" src="{{ staticFileUrl + field.url }}" />
            <span class="w-200px-icon my-2 px-3">{{ field.label }}</span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <!-- select multiple images END -->
  </ng-container>

  <ng-container *ngSwitchCase="'STAR_RATING'">
    <!-- star Rating -->
    <div #questionDiv class="py-5 D-Active 000">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <div
        class="d-flex flex-wrap my-2"
        *ngFor="let field of question.meta.fields"
      >
        <span class="w-200px">{{ field.label }}</span>
        <p-rating class="v4-ratting"
          [disabled]="disabled"
          [(ngModel)]="field.value"
          [cancel]="false"
        ></p-rating>
      </div>
    </div>
    <!-- star Rating End -->
    <hr />
  </ng-container>

  <ng-container *ngSwitchCase="'SMILE_RATING'">
    <div #questionDiv class="py-5 D-Active 001">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <div class="d-flex flex-wrap py-3">
        <div
          (click)="question.meta.value = field.label; checkConditionalQuestion()"
          class="{{
            question.meta.value == field.label
              ? 'rating-box-active'
              : 'rating-box'
          }} m-2"
          *ngFor="let field of question.meta.fields"
        >
          <img class="rating-width" src="{{ field.image }}" alt="loading" />
          <span class="clr-black my-2">{{ field.label }}</span>
        </div>
      </div>
      <hr />
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'MULTI_POINT_SCALE'">
    <!-- row section -->
    <div #questionDiv class="py-2 111 D-Active">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="survey-label">
          {{ question.questionText }}
        </span>
      </div>
      <div class="row col-12">
        <!-- col-1 col-2 section -->
        <div class="col-md-2 col-12"></div>
        <ng-container *ngFor="let column of question.meta.columns">
          <div class="col d-flex justify-content-center my-1">
            <span class="w-200px-icon">{{ column }}</span>
          </div>
        </ng-container>
      </div>
      <div class="row col-12" *ngFor="let field of question.meta.fields">
        <div class="col-md-2 col-12 my-1">
          <span class="w-200px-icon">{{ field.field.label }}</span>
        </div>
        <div class="col" *ngFor="let col of question.meta.columns">
          <div
            style="cursor: pointer"
            (click)="disabled ? {} : (field.field.value = col)"
            class="radio-bg d-flex justify-content-center my-1"
          >
            <p-radioButton
              [disabled]="disabled"
              [value]="col"
              [(ngModel)]="field.field.value"
            ></p-radioButton>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <!-- row section END -->
  </ng-container>
  <ng-container *ngSwitchCase="'MULTI_SELECT_SCALE'">
    <!-- Multiple row section -->
    <div #questionDiv class="py-5 D-Active 22">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <div class="row col-12">
        <!-- col-1 col-2 section -->
        <div class="col-md-2 col-12"></div>
        <ng-container *ngFor="let column of question.meta.columns">
          <div class="col d-flex justify-content-center my-1">
            <span class="w-200px-icon">{{ column }}</span>
          </div>
        </ng-container>
      </div>
      <div class="row col-12" *ngFor="let field of question.meta.fields">
        <div class="col-md-2 col-12 my-1">
          <span class="w-200px-icon">{{ field.field.label }}</span>
        </div>
        <div
          class="col"
          (mousedown)="disabled ? {} : addRemoveValueInFieldArray(field, col)"
          *ngFor="let col of question.meta.columns"
        >
          <div
            style="cursor: pointer"
            class="radio-bg d-flex justify-content-center my-1"
          >
            <p-checkbox
              [disabled]="disabled"
              name="{{ field.field.label }}"
              [value]="col"
              [(ngModel)]="field.value"
              (ngModelChange)="addRemoveValueInFieldArray(field, col)"
            ></p-checkbox>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <!-- Multiple row section END -->
  </ng-container>
  <ng-container *ngSwitchCase="'RANK_ORDER'">
    <!-- DropDown section -->
    <div #questionDiv class="py-2 D-Active">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="color-grey fw-bold">
          {{ question.questionText }}
        </span>
      </div>
      <div
        class="d-flex flex-wrap my-3"
        *ngFor="let field of question.meta.fields; let i = index"
      >
        <div class="w-200pixel d-flex justify-content-start align-items-center">
          <span class="w-200px-icon">{{ field.label }}</span>
        </div>
        <div class="mx-2 w-200pixel 1111">
          <span class="w-100">
            <p-dropdown class="ppp-dropdown"
              [disabled]="disabled"
              appendTo="body"
              (ngModelChange)="getRankDDValues(field, $event, question.meta)"
              [(ngModel)]="field.value"
              [options]="getRankDDValues2(question)"
              placeholder="{{ '-Select-' | translator }}"
            ></p-dropdown>
          </span>
        </div>
      </div>
      <hr />
    </div>
    <!-- DropDown section END -->
  </ng-container>
  <ng-container *ngSwitchCase="'DRAG_DROP'">
    <!-- drag drop section -->
    <div #questionDiv class="py-2 D-Active">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="color-grey fw-bold">
          {{ question.questionText }}
        </span>
      </div>
      <div class="d-flex 111">
        <div class="drop-ui">
          <div class="p-2 border-1 surface-border border-round w-15rem">
            <ul class="list-nonee flex flex-column gap-2 p-0 m-0">
              <li
                style="cursor: grab"
                *ngFor="let field of this.question.meta.fields"
                class="p-2 border-round drag-shaddow"
                pDraggable
                (onDragStart)="disabled ? {} : dragStart(field)"
                (onDragEnd)="disabled ? {} : dragEnd()"
              >
                {{ field.label }}
              </li>
            </ul>
          </div>
        </div>
        <div class="drag-ui">
          <p class="text-center color-grey 4444">
            Drag your choices here to rank them
          </p>
          <div
            class="p-2 border-1 surface-border border-round w-15rem"
            pDroppable
            (onDrop)="drop(question)"
          >
            <div class="d-flex justify-content-end my-3">
              <span class="d-and-d-text"
                >{{ question.meta.topAnchor }}
                <i class="pi pi-arrow-circle-up"></i
              ></span>
            </div>
            <ul
              class="list-nonee flex flex-column gap-2 p-0 m-0"
              *ngIf="question.meta.orderedFields"
            >
              <p-table
                class="tab-menu-bg"
                [value]="question.meta.orderedFields"
              >
                <ng-template
                  class="tab-menu-bg"
                  pTemplate="body"
                  let-product
                  let-index="rowIndex"
                >
                  <tr [pReorderableRow]="index">
                    <td pReorderableRowHandle style="cursor: grab">
                      <span
                        pReorderableRowHandle
                        class="p-2 border-round drag-shaddow"
                        style="cursor: grab"
                      >
                        {{ product.label }}
                      </span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </ul>
            <div class="d-flex justify-content-end my-3">
              <span class="d-and-d-text"
                >{{ question.meta.bottomAnchor }}
                <i class="pi pi-arrow-circle-down"></i
              ></span>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <!-- drag drop section END -->
  </ng-container>
  <ng-container *ngSwitchCase="'DATE_TIME'">
    <!-- Birthdate -->
    <div #questionDiv class="py-5 D-Active 33">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <div class="d-flex">
        <div class="my-3">
          <!-- <label for="day">{{ 'Day' | translator}}:</label> -->
          <select
            [disabled]="disabled"
            [(ngModel)]="question.meta.value.day"
            id="day"
            name="day"
            class="dob-select m-1"
          >
            <option value="">{{ "Day" | translator }}</option>
            <!-- Add day options here -->
            <option *ngFor="let day of days" value="{{ day }}">
              {{ day }}
            </option>
            <!-- Add more days as needed -->
          </select>

          <!-- <label for="month">{{ 'Month' | translator}}:</label> -->
          <select
            [disabled]="disabled"
            [(ngModel)]="question.meta.value.month"
            id="month"
            name="month"
            class="dob-select m-1"
          >
            <option value="">{{ "Month" | translator }}</option>
            <!-- Add month options here -->
            <option *ngFor="let month of months" value="{{ month }}">
              {{ month }}
            </option>
            <!-- Add more months as needed -->
          </select>

          <!-- <label for="year">{{ 'Year' | translator}}:</label> -->
          <select
            [disabled]="disabled"
            [(ngModel)]="question.meta.value.year"
            id="year"
            name="year"
            class="dob-select m-1"
          >
            <option value="">{{ "Year" | translator }}</option>
            <!-- Add year options here, e.g., from 1900 to the current year -->
            <!-- Example: -->
            <option *ngFor="let year of years" value="{{ year }}">
              {{ year }}
            </option>
            <!-- Add more years as needed -->
          </select>
        </div>
      </div>
      <hr />
    </div>
    <!-- Birthdate END -->
  </ng-container>
  <ng-container *ngSwitchCase="'CALENDAR'">
    <!-- calander -->
    <div #questionDiv class="py-5 D-Active 44">
      <label
        class="description"
        *ngIf="question.meta.description"
        [innerHTML]="question.meta.description | safeHTML"
      ></label>
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <div class="d-flex">
        <div class="d-flex my-3">
          <p-calendar
            class="survy-calnder"
            [disabled]="disabled"
            appendTo="body"
            [(ngModel)]="question.meta.value"
            [placeholder]="
              disabled ? getDatePlaceholder(question.meta.value) : ''
            "
            [showIcon]="true"
          ></p-calendar>
        </div>
      </div>
      <hr />
    </div>
    <!-- calander END -->
  </ng-container>
  <ng-container *ngSwitchCase="'PRESENTATION_TEXT'">
    <!-- descriptive full width bg purple -->
    <div #questionDiv class="py-5 D-Active 55">
      <div class="w-100 my-3">
        <div class="full-heading w-100">
          {{ question.questionText }}
        </div>
      </div>
      <hr />
    </div>
    <!-- descriptive END -->
  </ng-container>
  <ng-container *ngSwitchCase="'SECTION_HEADING'">
    <!-- descriptive -->
    <div #questionDiv class="py-5 D-Active 66">
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <hr />
    </div>
    <!-- descriptive END -->
  </ng-container>
  <ng-container *ngSwitchCase="'SECTION_SUB_HEADING'">
    <!-- descriptive -->
    <div #questionDiv class="py-5 D-Active 77">
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <hr />
    </div>
    <!-- descriptive END -->
  </ng-container>
  <ng-container *ngSwitchCase="'IMPACT_MEASUREMENT'">
    <!-- star Rating -->
    <div #questionDiv class="py-5 D-Active 88">
      <div class="my-3">
        <span class="heading">
          {{ question.questionText }}
        </span>
      </div>
      <label
        class="description"
        *ngIf="question.meta.correctAnswer"
        [innerHTML]="question.meta.correctAnswer | safeHTML"
      ></label>
      <div class="d-flex justify-content-start column">
        <div>
          <label class="mb-2 survey-label 3333">{{ 'Employee Answer' | translator }}</label>
          <textarea
            [disabled]="disabled"
            [(ngModel)]="question.meta.empAnswer"
            style="
              background-color: white;
              font-size: 20px;
              border: 4px;
              width: 100%;
              height: 150px;
            "
            rows="2"
            cols="30"
            class="border-4-v4 px-2"
          ></textarea>
        </div>
      </div>
      <div
        class="d-flex flex-wrap my-2"
        *ngFor="let field of question.meta.fields"
      >
        <span class="w-200px">{{ field.label }}</span>
        <p-rating class="v4-ratting"
          [disabled]="disabled"
          [(ngModel)]="field.value"
          [cancel]="false"
        ></p-rating>
      </div>
      <div class="d-flex justify-content-start column">
        <div>
          <label class="mb-2 survey-label 3333">{{ 'Comments' | translator }}</label>
          <textarea
            [disabled]="disabled"
            [(ngModel)]="question.meta.comment"
            style="
              background-color: white;
              font-size: 20px;
              border: 4px;
              width: 100%;
              height: 150px;
            "
            rows="2"
            cols="30"
            class="border-4-v4 px-2"
          ></textarea>
        </div>
      </div>
    </div>
    <!-- star Rating End -->
    <hr />
  </ng-container>
</ng-container>
